<template>
    <div class="page-header">
        <router-link class="btn btn-back" :to="{ path:'/Admin/List' }"><i class="las la-angle-left"></i></router-link>
    </div>
    <div class="voice-view" :class="{ 'admin-view':comp.is_admin }">
        <!-- voice rec & up start -->
        <div class="voice-rec">
            <div class="voice-script">
                <span>{{ comp.view.script }}</span><br>
                <span class="pron">[{{ comp.view.pronunciation }}]</span>
            </div>
            <div class="btn-box" :class="{ 'rec-end':comp.info.mergeURL!=null, 'hide':comp.mp3up.is_show==true }">
                <button class="btn btn-rec" :class="{ 'active':comp.info.mergeURL!=null }" @click="comp.onRecording" aria-label="voice rec">
                    <i v-if="comp.info.status==0" class="las la-microphone"></i>
                    <span v-if="comp.info.status==1">...</span>
                    <i v-if="comp.info.status==2" class="las la-stop"></i>
                </button>
                <button class="btn btn-play" :class="{ 'active':comp.info.mergeURL!=null }" @click="comp.onPlay('')" aria-label="rec voice play">
                    <i v-if="comp.play.status==0" class="las la-play"></i>
                    <i v-if="comp.play.status==1" class="las la-headphones"></i>
                </button>
                <button class="btn btn-native" :class="{ 'active':comp.info.mergeURL!=null, 'checked':comp.info.isnative==true }" @click="comp.info.isnative=!comp.info.isnative">Native</button>
                <button class="btn btn-send" :class="{ 'active':comp.info.mergeURL!=null }" @click="comp.onSendVoice()" aria-label="send voice to server"><i class="lar la-paper-plane"></i></button>

                <button class="btn btn-up-open" :class="{ 'hide':comp.info.mergeURL!=null||comp.info.status!=0 }" @click="comp.mp3up.is_show=true" aria-label="file upload show"><i class="las la-cloud-upload-alt"></i></button>
            </div>
            <audio id="audioplayer" class="rr-voice" :src="comp.info.mergeURL" @ended="comp.gotEnded"></audio>

            <div class="upload-box" :class="{ 'hide':comp.mp3up.is_show!=true }">
                <button class="btn-close" :class="{ 'active':comp.mp3up.is_native=='Y' }" @click="comp.hideMp3UpBox()" aria-label="file upload hide"><i class="las la-times-circle"></i></button>
                <ReumFileUploader class="up-file" accept="audio/mp3" v-model:filename="comp.mp3up.filename" v-model:url="comp.mp3up.url"></ReumFileUploader>
                
                <button class="btn-up-submit" v-if="comp.mp3up.url!=''" @click="comp.uploadMp3()" aria-label="file upload to server"><i class="las la-cloud-upload-alt"></i></button>
                <div class="chk-native"><label><button class="btn-isnative" :class="{ 'active':comp.mp3up.is_native=='Y' }" @click="comp.checkUpNative()" aria-label="check native"><i class="las la-check-circle"></i></button> is Native Voice?</label></div>
            </div>
        </div>
        <!-- voice rec & up end -->

        <!-- voice reporting standard -->
        <div class="voice-list">
            <div class="voice-item grade-info">
                <div class="item-body">
                    <div class="grade ev-input-head">
                        <span class="best">● best <input type="text" class="base-lv" v-model="comp.opts.base.best" maxlength="3"></span>
                        <span class="good">● good <input type="text" class="base-lv" v-model="comp.opts.base.good" maxlength="3"></span>
                        <span class="average">● average <input type="text" class="base-lv" v-model="comp.opts.base.average" maxlength="3"></span>
                        <span class="fair">● fair <input type="text" class="base-lv" v-model="comp.opts.base.fair" maxlength="3"></span>
                        <span class="poor">● poor <input type="text" readonly class="base-lv" v-model="comp.opts.base.poor" maxlength="3"></span>
                        <span class="pitch-weight">● pitch direction weight <input type="text" class="base-lv" v-model="comp.opts.base.pitch_weight" maxlength="3" onclick="this.select()"></span>
                        <button class="btn-apply" @click="comp.doEvaluates">Set&View</button>
                    </div>
                </div>
            </div>

            <div class="voice-item grade-info">
                <div class="item-body">
                    <div class="pitch-dist">
                        <span class="txt" :dist="comp.control.pitch.dist">Pitch Distance Guide&nbsp;:&nbsp;Avg:&nbsp;{{ comp.control.pitch.dist.toFixed(2) }}Hz, </span>
                        <span class="txt">&nbsp;Min:&nbsp;{{ comp.control.pitch.min.toFixed(2) }}Hz, </span>
                        <span class="txt">&nbsp;Max:&nbsp;{{ comp.control.pitch.max.toFixed(2) }}Hz</span>
                        <label class="dist-compare">Pitch distance compare this script : <input type="checkbox" v-model="comp.opts.usepitchdist" @change="comp.doCompare"></label>
                    </div>
                </div>
            </div>
            <div class="voice-item grade-info">
                <div class="item-body">
                    <div class="grade ev-input-head">
                        <span class="best">● best <input type="text" class="base-lv" v-model="comp.opts.base.pitch_guide.best" maxlength="3"></span>
                        <span class="good">● good <input type="text" class="base-lv" v-model="comp.opts.base.pitch_guide.good" maxlength="3"></span>
                        <span class="average">● average <input type="text" class="base-lv" v-model="comp.opts.base.pitch_guide.average" maxlength="3"></span>
                        <span class="fair">● fair <input type="text" class="base-lv" v-model="comp.opts.base.pitch_guide.fair" maxlength="3"></span>
                        <span class="poor">● poor <input type="text" readonly class="base-lv" v-model="comp.opts.base.pitch_guide.poor" maxlength="3"></span>
                        <span class="pitch-weight">● pitch distance weight <input type="text" class="base-lv" v-model="comp.opts.base.pitch_weight_dist" maxlength="3" onclick="this.select()"></span>
                        <button class="btn-apply" @click="comp.doEvaluates">Set&View</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- uploaded voice list -->
        <div class="bar"><span>voice list</span></div>
        <div class="voice-list">
            <div class="voice-item">
                <div class="item-head">
                    <div class="head">No.</div>
                </div>
                <div class="item-body">
                    <div class="script">
                        <div class="head">평가문장</div>
                    </div>
                    <div class="report">
                        <div class="head">Pronunciation</div>
                        <div class="head">Pitch</div>
                        <div class="head">Total</div>
                        <div class="head">Best Pitch</div>
                        <div class="head">Speech Time<br>WPM</div>
                    </div>
                    <div class="body-tail">
                        <div class="head">Evaluator<br>Score</div>
                        <div class="head">Native?</div>
                    </div>
                </div>
                <!-- <div class="item-tail"></div> -->
            </div>

            <!-- 학습자 START -->
            <template v-for="(irow, i) in comp.list" :key="i">
                <div class="voice-item" v-if="irow.isnative=='N'" :voice-len="irow.len_tot" :avg-score="irow.avg_score" :avg-grade="irow.avg_grade" :guide="(!irow.pitch_dist?'':irow.pitch_dist.normal)">
                    <div class="item-head">
                        <div class="num">{{ i+1 }}</div>
                    </div>
                    <div class="item-body">

                        <!-- script section -->
                        <div class="script" @click="pop.showView(irow)">
                            <!-- base script -->
                            <div class="item">{{ irow.script }}</div>
                            <!-- base grade -->
                            <div class="item grade">
                                <template v-for="(jrow, j) in irow.phonemes" :key="j">
                                    <span :score="jrow.score" :class="comp.mkClass(irow.phonemes[j].grade, j)" @hover="comp.onHover(j)" :token="jrow.token_txt">{{ jrow.token_txt }}</span>
                                </template>
                            </div>
                            <!-- pitch distance guide grade -->
                            <div class="item grade" :guide="(!irow.pitch_dist?'':irow.pitch_dist.normal)">
                                <div class="grade">
                                    <template v-for="(jrow, j) in irow.phonemes" :key="j">
                                        <span :score="jrow.score_pd" :class="comp.mkClass(irow.phonemes[j].grade_pd, j)" @hover="comp.onHover(j)" :token="jrow.token_txt">{{ jrow.token_txt }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <!-- report section -->
                        <div class="report" v-if="irow.avg_score">
                            <div class="list">
                                <div class="item">
                                    <caption>SCORE : </caption>
                                    <span :class="irow.avg_grade">{{ irow.avg_score.toFixed(1) }}</span>
                                    <span>/5</span>
                                </div>
                                <!-- pitch dir -->
                                <div class="item">
                                    <caption>PITCH DIR : </caption>
                                    <span :class="irow['avg_score_p']">{{ irow['avg_score_p'].toFixed(1) }}</span>
                                    <span>/5</span>
                                </div>
                                <!-- pronunce + pitch dir -->
                                <div class="item">
                                    <caption>SCORE(pitch+) : </caption>
                                    <span :class="irow['avg_grade_a']">{{ irow['avg_score_a'].toFixed(1) }}</span>
                                    <span>/5</span>
                                    <span v-if="comp.opts.usepitchdist" class="pdis-score" :class="irow['pitch_dist']['t_grade']">{{ irow['pitch_dist']['t_score'].toFixed(1) }}</span>
                                </div>
                                <div class="item" @click="comp.onMarkNative(irow['pitch_dir']['best'])">
                                    <caption>Pitch Best : </caption>
                                    <div class="btn btn-play" @click="comp.onPlay(irow)">
                                        <i v-if="comp.play.idx==irow.idx" class="las la-volume-up"></i>
                                        <i v-else class="las la-play"></i>
                                    </div>
                                    <div class="mark-best" @click="comp.onPlayIdx(irow['pitch_dir']['best'])">
                                        <span>{{ irow['pitch_dir']['best'] }}</span>
                                        <i v-if="comp.play.idx==irow['pitch_dir']['best'] " class="las la-volume-up"></i>
                                        <i v-else class="las la-play"></i>
                                    </div>
                                </div>
                                <div class="item">
                                    <caption>Speech Time : </caption>
                                    <span>{{ (irow.len_tot/1000).toFixed(2) }}s</span>
                                </div>
                            </div>
                            <div class="list grade">
                                <!-- evaluation grade -->
                                <div class="item">
                                    <caption>GRADE : </caption>
                                    <span :class="irow.avg_grade">{{ irow.avg_grade }}</span>
                                </div>
                                <div class="item">
                                    <caption>PITCH DIR : </caption>
                                    <span :class="irow['avg_grade_p']">{{ irow['avg_grade_p'] }}</span>
                                </div>
                                <div class="item">
                                    <caption>GRADE(pitch+) : </caption>
                                    <span :class="irow['avg_grade_a']">{{ irow['avg_grade_a'] }}</span>
                                    <span v-if="comp.opts.usepitchdist" class="pdis-score" :class="irow['pitch_dist']['t_grade']">{{ irow['pitch_dist']['t_grade'] }}</span>
                                </div>
                                <div class="item">
                                    <caption>Best Pitch : </caption>
                                    <span>{{ (irow['pitch_dir']['rate']).toFixed(2) }}%</span>
                                </div>
                                <div class="item">
                                    <caption>WPM : </caption>
                                    <span>{{ (irow.words_cnt/((irow.len_tot/1000)/60)).toFixed(2) }}w/m</span>
                                </div>
                            </div>
                            <div class="list pitch">
                                <!-- pitch distance analysis -->
                                <div class="item">
                                    <caption>MIN : </caption>
                                    <span>min: {{ (irow['pitch_dist']["min"]).toFixed(2) }}Hz</span>
                                </div>
                                <div class="item">
                                    <caption>MAX : </caption>
                                    <span>max: {{ (irow['pitch_dist']["max"]).toFixed(2) }}Hz</span>
                                </div>
                                <div class="item">
                                    <caption>Distance : </caption>
                                    <span>dist:{{ (irow['pitch_dist']["val"]).toFixed(2) }}Hz</span>
                                </div>
                                <div class="item rate">
                                    <span>rate:{{ comp.calcRatePitchDist(irow)[0] }}%</span>
                                    <div class="rate-bar" :class="comp.calcRatePitchDist(irow)[1]" :style="{ 'width':comp.calcRatePitchDist(irow)[0]+'%' }" ></div>
                                    <div class="rate-lock"></div>
                                </div>
                                <div class="item grade">
                                    <caption>Grade : </caption>
                                    <div class="pd-result">score: <span :class="irow['pitch_dist']['grade']">{{ (irow['pitch_dist']['score']) }}</span><span>/5</span></div>
                                    <div class="pd-result">grade: <span :class="irow['pitch_dist']['grade']">{{ irow['pitch_dist']['grade'] }}</span></div>
                                </div>
                            </div>
                        </div>

                        <!-- native check -->
                        <div class="body-tail" v-if="irow.avg_score">
                            <div class="item">
                                <caption>Evaluator Score : </caption>
                                <input type="text" class="demo-score" maxlength="4" v-model="irow.demo_no" @blur="comp.updateScore(irow)">
                            </div>
                            <div class="item">
                                <caption>Native? : </caption>
                                <input type="checkbox" v-if="comp.is_admin" v-model="irow.native" @change="comp.updateNative(irow.idx)">
                                <span v-else>No</span>
                            </div>
                        </div>
                        <div class="report" v-else>
                            <div class="item">
                                <span class="item">{{ irow.avg_score?'':'(평가실패)' }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- play button & right section -->
                    <div class="item-tail">
                        <button class="btn btn-play" @click="comp.onPlay(irow)">
                            <i v-if="comp.play.idx==irow.idx" class="las la-volume-up"></i>
                            <i v-else class="las la-play"></i>
                        </button>
                        <button type="button" class="btn-re-ev" v-if="comp.uidx==20281" @click="comp.reEv(irow)"><i class="las la-retweet"></i></button>
                    </div>
                </div>
            </template>
            <!-- 학습자 END -->

            <!-- 원어민 START -->
            <template v-for="(irow, i) in comp.list" :key="i">
                <div class="voice-item native" :class="{ 'marked':irow.idx==comp.mark_native }" v-if="irow.isnative=='Y'" :voicelen="irow.len_tot">
                    <div class="item-head">
                        <button type="button" class="btn btn-check" :class="{ 'checked':comp.selected.indexOf(irow.idx)>-1 }" @click="comp.selectNative(irow.idx)">
                            <i class="las la-check"></i>
                        </button>
                        <span class="idx">{{ irow.idx }}</span>
                    </div>
                    <div class="item-body">
                        <!-- <span class="script">{{ irow.script }}</span> -->
                        <!-- <span class="script" @click="comp.doEvaluate(irow)"> -->
                        <div class="script">
                            <div class="item">{{ irow.script }}</div>
                            <div class="item grade">
                                <template v-for="(jrow, j) in irow.phonemes" :key="j">
                                    <!-- <span v-if="j>0">·</span> -->
                                    <span :score="jrow.score" :class="comp.mkClass(irow.phonemes[j].grade, j)" @hover="comp.onHover(j)">{{ jrow.token_txt }}</span>
                                </template>
                            </div>
                        </div>
                        <div class="report">
                            <div class="list">
                                <div class="item">&nbsp;</div>
                                <div class="item">&nbsp;</div>
                                <div class="item">&nbsp;</div>
                                <div class="item">&nbsp;</div>
                                <div class="item">
                                    <caption>Speech Time : </caption>
                                    <span>{{ (irow.len_tot/1000).toFixed(2) }}s</span>
                                </div>
                            </div>
                            <div class="list">
                                <div class="item">&nbsp;</div>
                                <div class="item">&nbsp;</div>
                                <div class="item">&nbsp;</div>
                                <div class="item">&nbsp;</div>
                                <div class="item">
                                    <caption>WPM : </caption>
                                    <span>{{ (irow.words_cnt/((irow.len_tot/1000)/60)).toFixed(2) }}w/m</span>
                                </div>
                            </div>
                            <div class="list pitch">
                                <div class="item">
                                    <caption>MIN : </caption>
                                    <span>min: {{ (irow['pitch_dist']["min"]).toFixed(2) }}Hz</span>
                                </div>
                                <div class="item">
                                    <caption>MAX : </caption>
                                    <span>max: {{ (irow['pitch_dist']["max"]).toFixed(2) }}Hz</span>
                                </div>
                                <div class="item">
                                    <caption>DIST : </caption>
                                    <span>dist: {{ (irow['pitch_dist']["val"]).toFixed(2) }}Hz</span>
                                </div>
                                <div class="item">&nbsp;</div>
                                <div class="item">&nbsp;</div>
                            </div>
                        </div>
                        <div class="body-tail" v-if="irow.avg_score">
                            <div class="item"></div>
                            <div class="item">
                                <caption>Native? : </caption>
                                <input type="checkbox" v-model="irow.native" @change="comp.updateNative(irow.idx)">
                            </div>
                        </div>
                    </div>
                    <div class="item-tail">
                        <button type="button" class="btn btn-play" @click="comp.onPlay(irow)">
                            <i v-if="comp.play.idx==irow.idx" class="las la-volume-up"></i>
                            <i v-else class="las la-play"></i>
                        </button>
                        <button type="button" class="btn-re-ev" v-if="comp.uidx==20281" @click="comp.reEv(irow)"><i class="las la-retweet"></i></button>
                    </div>
                </div>
            </template>
            <!-- 원어민 END -->
        </div>

        <audio id="audioplayer2" class="rr-voice" :src="comp.play.vpath" @ended="comp.gotEnded"></audio>


        <!-- modal - evaluation report -->
        <pop-detail v-model="pop.info" :control="comp.control" :option="comp.opts" :class="{ 'open':pop.show==true }" @close="pop.hideView"></pop-detail>
        
    </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import axios from "axios";
import { useToast } from 'vue-toastification';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ReumFileUploader from "@/components/ReumLib/UI/ReumFileUploader.vue";
import PopDetail from '@/components/Popup/pop_detail.vue';

import { useEvaluator } from '@/utils/prontest'

export default {
    name: "View",
    components: {
        ReumFileUploader,
        PopDetail
    },
    props:{ },
    setup() {
        const toast  = useToast();
        const router = useRouter();
        const route = useRoute();
        const store = useStore()
        const ev = useEvaluator()

        const pop = reactive({
            info : { },
            show : false,

            showView:(iv)=>{
                if( comp.control.lens.length <= 0 ) return

                if( !iv.avg_score ) return

                pop.info = iv
                pop.show = true
            },
            hideView:()=>{
                pop.info = {}
                pop.show = false
            },
        })

        const comp = reactive({
            audioplayer : null, audioplayer2 : null,
            idx:0, uidx:0, is_admin:false,
            info: {
                text:"",
                status: 0,
                chunks: [],
                mergeURL: null,
                source:null,
                base64: null,
                isnative:false,
            },
            rec_config: {
                audio: true,
                video:false
            },
            recorder : null,
            list:[], total:0,
            play: { idx:0, vpath:"", status:0 },
            selected: [],
            modified: { idx:'', script:'' },
            view : {
                idx : 0,
                script: '',
                phonemes:[],
            },
            control : {
                // 분석 대상이 되는 원어민
                idxl : [],
                list : [],
                lens : [],
                pers : [],
                avgs : [],
                pitch : { dist:0, min:0, max:0 },
            },
            opts : {
                base : { 
                    best:10, good:20, average:30, fair:40, poor:'etc', 
                    pitch_weight:20, pitch_weight_dist:10, 
                    pitch_guide:{ 
                        best:30, good:50, average:70, fair:90, poor:'etc'
                    } 
                },
                usepitchdist : true
            },
            mp3up : {
                is_show : false,
                filename : '',
                url: '',
                is_native:'N'
            },
            mark_native : 0,

            gotStream: (mediaStream) => {
                console.info("gotStream");
                comp.info.status = 2;
                window.streamReference = mediaStream;
                comp.recorder = null;
                comp.recorder = new MediaRecorder(mediaStream);
                comp.recorder.start(100);
                comp.recorder.ondataavailable = comp.audioDataHandler;
            },
            onRecording: () => {
                switch(comp.info.status){
                    case 2: comp.onStop(); break;
                    default: comp.onRecord(); break;
                }
            },
            onRecord: () => {
                console.info("Record");
                comp.info.status = 1;
                comp.info.chunks = [];
                navigator.mediaDevices.getUserMedia(comp.rec_config)
                .then(comp.gotStream)
                .catch(err => {
                    console.error(err.name + ": " + err.message)
                    toast.error(err.name + ": " + err.message)
                    comp.info.status = 0;
                });
            },
            onStop: () => {
                console.info("Stop");
                comp.info.status = 3;
                if (!window.streamReference) {
                    return;
                }
                window.streamReference.getAudioTracks().forEach(track => {
                    track.stop();
                });
                window.streamReference = null;

            },
            onSendVoice: () => {
                let params = {
                    idx: comp.idx,
                    isnative: comp.info.isnative==true?'Y':'N',
                    raw:comp.info.base64,
                    uidx: comp.uidx
                }
                axios.post("/ai/voice_upload", params).then((res) => {
                    if(res.data.err == 0) {
                        comp.info.base64 = null
                        comp.info.mergeURL = null
                        toast.success("전송했습니다.");
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg);
                    }
                }).catch((err) => {
                    toast.error("연결에 오류가 있습니다. :: ", err);
                });
            },
            audioDataHandler(event){
                console.info("Push");
                comp.info.chunks.push(event.data);
                if(comp.info.status == 3) {
                    let mergeBlob = new Blob(comp.info.chunks,{type:'audio/wav; codecs=MS_PCM'})
                    comp.info.mergeURL = URL.createObjectURL(mergeBlob);

                    let reader = new FileReader();
                    reader.onload = function(event){
                        comp.info.base64 = event.target.result;
                    }; // data url!
                    comp.info.source = reader.readAsDataURL(mergeBlob);
                    comp.info.status = 0;
                }
            },
            onPlayIdx:(idx) => {
                let o = null
                for(let i=0; i<comp.list.length; i++){
                    let irow = comp.list[i]
                    if( irow.idx == idx ){
                        o = irow
                        break;
                    }
                }
                if( o && o.idx )
                    comp.onPlay(o)
            },
            onPlay:(o) => {
                if( o ){
                    comp.play.idx = o.idx
                    comp.play.vpath = o.vpath
                    // let audioplayer = document.getElementById("audioplayer2")
                    setTimeout(() =>{
                        comp.audioplayer2.play();
                    }, 200)

                } else {
                    comp.play.idx = 0
                    comp.play.vpath = ""
                    // let audioplayer = document.getElementById("audioplayer")
                    setTimeout(() =>{
                        comp.play.status = 1
                        comp.audioplayer.play();
                    }, 200)
                }
            },
            gotEnded:() => {
                console.log('play done')
                comp.play.idx = 0
                comp.play.status = 0
            },

            reEv: (o) => {
                let params = {
                    idx: o.idx
                }
                axios.get("/ai/wav_test", { params:params }).then((res) => {
                    console.log(res.data)
                    comp.doSearch()
                })
            },

            doCompare: () => {
                let params = {
                    idx : comp.idx,
                    isCompared : comp.opts.usepitchdist==true?'Y':'N'
                }
                axios.post("/ai/set_compare_script", params).then((res) => {
                    if( res.data.err == 0 ){
                        console.log(res)
                    }
                })
            },

            doInfo: () => {
                let params = {
                    idx : comp.idx
                }
                axios.get("/ai/script_info", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.view = res.data
                        // comp.(comp.view.phonemes)
                    }
                })
            },

            doSearch: () => {
                let params = {
                    idx : comp.idx
                }
                axios.get("/ai/voice_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list

                        for(let i=0; i<comp.list.length; i++){
                            let irow = comp.list[i]
                            irow['native'] = false
                            if( irow.isnative == 'Y' ){
                                comp.selected.push(irow.idx)
                                irow['native'] = true
                            }
                        }

                        comp.doEvaluates()
                    }
                })
            },

            updateScore:(o)=>{
                let params = { idx:o.idx, score:o.demo_no }
                axios.post('/ai/update_score', params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doSearch()
                    } else {
                        toast.error("refresh and re-operate.")
                    }
                })
            },

            updateNative:(idx)=>{
                let params = { idx:idx }
                axios.post('/ai/update_native', params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doSearch()
                    } else {
                        toast.error("refresh and re-operate.")
                    }
                })
            },

            mkClass:(grade, j)=>{
                return 'phonemes-' + j + ' ' + (!grade?'':grade)
            },

            calcRatePitchDist: (o) => {
                let w = 0
                let c = 'best'
                if( parseInt(comp.control.pitch.dist) > 0 ){
                    w = parseInt((o['pitch_dist']["val"])/(comp.control.pitch.dist)*100.0)
                }
                if( w < (100 - comp.opts.base.pitch_guide.best) ){
                    c = 'good'
                }
                if ( w < (100 - comp.opts.base.pitch_guide.good) ) {
                    c = 'average'
                }
                return [(w>100?'100':w), c]
            },

            onMarkNative:(idx) => {
                comp.mark_native = idx
            },

            selectNative:(idx)=>{
                if( comp.selected.indexOf(idx) > -1 ){
                    comp.selected.splice(comp.selected.indexOf(idx), 1)
                } else {
                    comp.selected.push(idx)
                }
                if( comp.selected.length <= 0 ){
                    toast.warning("You must select at least one.")
                    comp.selected.push(idx)
                }
                // console.log(comp.selected.indexOf(idx), comp.selected)

                comp.doEvaluates()
            },

            doEvaluatesPitchDist: () => {
                for(let i=0; i<comp.list.length; i++){
                    let irow = comp.list[i]

                    irow = ev.run(irow, comp.control)
                }
            },

            doEvaluates: () => {
                let ctrls = [];
                for(let i=0; i<comp.list.length; i++){
                    let irow = comp.list[i]
                    if( comp.selected.indexOf(irow.idx) >= 0 ){
                        ctrls.push(irow)
                    }
                }

                ev.opts = comp.opts
                comp.control = ev.getRules(ctrls)

                for(let i=0; i<comp.list.length; i++){
                    let irow = comp.list[i]

                    // irow = comp.doEvaluate(irow)
                    irow = ev.run(irow, comp.control)
                }
            },


            uploadMp3: () => {
                let param = {
                    idx: comp.idx,
                    path : comp.mp3up.url,
                    isnative : comp.mp3up.is_native,
                    uidx : comp.uidx
                }
                axios.post('/ai/mp3Link2Sample', param).then((res) => {
                    if( res.data.err == 0 ){
                        comp.hideMp3UpBox()
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg)
                    }
                })
            },

            checkUpNative: () => {
                comp.mp3up.is_native = (comp.mp3up.is_native=='Y'?"N":"Y")
            },

            hideMp3UpBox: () => {
                comp.mp3up.is_show = false
                comp.mp3up.filename = ''
                comp.mp3up.url = ''
                comp.mp3up.is_native = 'N'
            },

        });

        onMounted(() => {
            comp.audioplayer = document.getElementById("audioplayer")
            comp.audioplayer2 = document.getElementById("audioplayer2")

            comp.idx = !route.params.idx?0:route.params.idx

            if( !comp.idx ) {
                router.back()
            }

            comp.uidx = store.state.user.idx
            comp.is_admin = store.state.user.isAdmin=='Y'?true:false

            ev.opts = comp.opts

            comp.doInfo()
            comp.doSearch()

        });

        return { comp, pop };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";
    .page-header {
        position:fixed; top:0; left:0; width:calc(100% - 90px); height:50px; z-index:910; background-color:#fff; border-bottom: 1px solid #ececec;
        .btn-back {
            position:fixed; top:5px; left:0; width:40px; height:40px; font-size:30px; text-align:center; line-height:40px; color:#929292; z-index:2;
        }
    }
    .voice-view {
        .voice-rec {
            padding:40px 0px 30px;
            &::after {
                display:block; content:''; clear:both;
            }
            .voice-script {
                font-size:1.5rem; text-align:center;
                .pron {
                    font-size:1rem; font-family: 'noto sans-serif';
                }
            }
            .btn-box {
                position:relative; margin-left:calc(50% - 30px); text-align:left; padding-top:10px; max-height:122px;
                -webkit-transition: .4s ease-in-out; -moz-transition: .4s ease-in-out; -o-transition: .4s ease-in-out; transition: .4s ease-in-out;
                visibility: visible;
                &.rec-end {
                    -webkit-transition: 1.0s ease-in-out; -moz-transition: 1.0s ease-in-out; -o-transition: 1.0s ease-in-out; transition: 1.0s ease-in-out;
                    left:-32px;
                }
                &::after {
                    display:block; content:''; clear:both;
                }
                &.hide {
                    opacity:0; max-height:0px; overflow:hidden; visibility: hidden;
                }
            }
            .btn {
                display:inline-block; width:60px; height:60px; padding: 3px 10px; margin-top:10px; border: 1px solid #ddd; border-radius: 50px; 
                color: #FFF; font-size:1.4rem; text-align:center;
                opacity: 0;
                -webkit-transition: .4s ease-in-out; -moz-transition: .4s ease-in-out; -o-transition: .4s ease-in-out; transition: .4s ease-in-out;
                &.btn-rec {
                    position: absolute; left: 0px; z-index:2;
                    -webkit-animation: slide 0.5s forwards; -webkit-animation-delay: 2s; animation: slide 0.5s forwards; animation-delay: 2s;
                    background-color: rgb(255, 81, 81);
                    opacity:1 !important;
                    &.active {
                        left:-62px;
                    }
                }
                &.btn-play {
                    background-color:rgb(132, 196, 49);
                }
                &.btn-native {
                    display: none;
                    margin-left:2px; font-size:13px; color:#666;
                    &.checked {
                        background-color:rgb(243, 210, 65); color:#fff;
                    }
                }
                &.btn-send {
                    display: none;
                    background-color: rgb(122, 134, 238); margin-left:2px;
                }
                &.active {
                    display:inline-block;
                    opacity: 1 !important; visibility: visible;
                }
                &.btn-up-open {
                    position:absolute;top:10px;left:60px;
                    opacity:1; background-color:rgb(136, 158, 106);
                    &.hide {
                        opacity:0; overflow:hidden; visibility: hidden;
                    }
                }
            }
            .upload-box {
                -webkit-transition: .4s ease-in-out; -moz-transition: .4s ease-in-out; -o-transition: .4s ease-in-out; transition: .4s ease-in-out;
                height:80px; padding-top:20px;
                &.hide {
                    height:0px; overflow:hidden; opacity:0;
                }
                .up-file {
                    display:inline-block; width:200px;
                }
                .btn-isnative {
                    width:22px; height:22px; font-size:16px; padding:0; vertical-align:middle;border: 1px solid rgb(2, 105, 2); border-radius: 3px; color:rgb(2, 105, 2); margin-left:1px;
                    &.active {
                        background-color:rgb(187, 227, 135); 
                    }
                }
                .btn-up-submit {
                    width:45px; height:22px; font-size:18px; padding:0; vertical-align:middle;background-color:rgb(122, 134, 238); border: 1px solid rgba(122, 134, 238, 0.8); border-radius: 3px; color:#fff; margin-left:1px;
                }
                .btn-close {
                    width:22px; height:22px; font-size:16px; padding:0; border:0; background:transparent; vertical-align:middle; margin-right:1px; color:#fc2415;
                }
                .chk-native {
                    padding-top:4px; font-size:12px;
                }
            }
        }

        .bar {
            position:relative; width:calc(100% - 40px); height:20px; padding:10px 0px; border-top:1px solid #c8c8c8; margin:20px 20px 0;
            span {
                position:absolute; top:-10px; left:0; right:0; width:130px; margin:0 auto; text-align:center; background-color:#f9f9f9; color:#999;
            }
        }

        .voice-list {
            width: 100%; overflow: hidden; overflow-x: auto;
            padding:0 20px 40px;
            .voice-item {
                position:relative; border-bottom:1px solid #c8c8c8; vertical-align:middle; min-width:820px;

                &:hover {
                    background-color:#fff;
                }
                &.marked {
                    background-color:rgba(238, 197, 122, 0.2);
                }
                &.grade-info {
                    .item-body {
                        width:100%; margin:0;
                    }
                }
                .title {
                    display:block; text-align:left; height:inherit; color:#929292;
                }
                .item-body {
                    position:relative; margin-left:30px;
                    width:calc(100% - 30px); min-height:30px; text-align:left; vertical-align:middle;
                    display:flex;justify-content: left; align-items: center; padding:0 10px;
                    .script {
                        width:50%; min-width:325px;
                        height:100%; border-left:1px solid #eaeaea; border-right:1px solid #eaeaea; cursor:pointer;
                        .head {
                            text-align:center; font-size:11px; 
                        }
                        .item {
                            min-height:30px; border-top:1px solid #eaeaea;
                            padding:5px 10px 4px;
                            &:first-child {
                                border-top-width: 0;
                            }
                        }
                    }

                    .report {
                        display:none;
                        width:calc(50% - 120px); min-width:325px;

                        .head {
                            float:left; width:calc(100% / 5); min-width:65px;
                            font-size:11px; text-align:center; border-right:1px solid #efefef;
                            &:last-child {
                                border-right-width:0;
                            }
                        }
                        .list {
                            height:30px; line-height:28px; border-top:1px solid #eaeaea;
                            &:first-child {
                                border-top-width:0;
                            }

                        }
                        .item {
                            position:relative;
                            float:left; width:calc(100% / 5); min-width:65px; font-size:12px; text-align:center;
                            > div, > span {
                                vertical-align:middle; word-break: break-word; line-height:20px;
                            }
                            .demo-score {
                                width:40px; height:20px; font-size:12px; text-align:center; border-radius:0; outline:none; border:1px solid #c8c8c8;
                            }
                            .mark-best {
                                display:inline-block;
                                width:40px; height:22px; line-height:20px; border:1px solid #c8c8c8; border-left:0; background-color:#efefef; padding:0 3px;
                                > i {
                                    cursor:pointer;
                                }
                            }
                            .pd-result {
                                font-size:10px; line-height:120%; text-align:left; padding-left:10px; letter-spacing:-0.5px;
                            }
                            .pdis-score {
                                position:absolute; bottom:0; right:5px; 
                                font-size:10px; line-height:120%;
                            }
                            .btn-play {
                                display:inline-block;
                                width:22px; height:22px; line-height:20px;
                            }
                        }

                        .pitch {
                            .item {
                                span {
                                    font-size:10px;
                                }
                                &.rate {
                                    position:relative;
                                    span {
                                        z-index:2;
                                    }
                                    .rate-bar {
                                        position:absolute;bottom:0;left:0;height:4px; z-index:1;
                                        &.best {
                                            background-color:rgba(71, 68, 247, 0.4);
                                        }
                                        &.good {
                                            background-color:rgba(29, 166, 0, 0.4);
                                        }
                                        &.average {
                                            background-color:rgba(255, 235, 0, 0.4);
                                        }
                                    }
                                    .rate-lock {
                                        position:absolute;bottom:0;left:0;width:100%;height:4px; background-color:rgba(30, 30, 30, 0.1); z-index:0;
                                    }
                                }
                            }
                        }
                    }

                    .body-tail {
                        display:none;
                        width:120px; min-width:120px; font-size:11px; border-left:1px solid #eaeaea; text-align: center;
                        .head, .item {
                            float:left; width:59px;
                            font-size:11px; text-align:center; border-right:1px solid #efefef;
                            &:last-child {
                                border-right-width:0;
                            }
                        }
                        input[type=checkbox] {
                            width:18px; height:18px; padding:0; margin:2px 0 0; border:1px solid #c8c8c8; cursor:pointer;
                        }
                        label {
                            margin-left:10px; 
                            padding-left:10px; border-left:1px solid #c8c8c8;
                        }
                        .demo-score {
                            width:40px; height:22px; font-size:12px; text-align:center; border-radius:0; outline:none; border:1px solid #c8c8c8;
                        }
                    }

                    .grade {
                        display:none;
                        .best { color:#4744f7; }
                        .good { color:#1da600; }
                        .average { color:#f7c606; }
                        .fair { color:#ff770d; }
                        .poor { color:#fc2415; }

                    }

                    .ev-input-head {
                        display:none; font-size:11px;
                        .base-lv {
                            width:20px; height:20px; text-align:center; color:#666; margin-right:10px; border-radius:0; border: 1px solid #c8c8c8; font-size:12px; line-height:18px; outline:none; padding:0;
                        }

                        .btn-apply {
                            width:60px; height:22px; padding:0; border: 1px solid #c8c8c8; color:#666; font-size:12px;
                            &:hover {
                                border-color:#999; background-color:#d0d0d0; color:#fff;
                            }
                        }
                    }

                    caption {
                        display:none;
                    }

                }
                .item-head {
                    position:absolute; top:0; left:0; width:30px; height:30px; line-height:30px;
                    button {
                        width:100%; height:100%; border:0; 
                        .la-check {
                            display:block;
                        }
                        &.checked {
                            display: none;
                            background-color:rgb(187, 227, 135); color:rgb(2, 105, 2);
                        }
                    }
                    .num {
                        width:100%; height:100%; line-height:28px; vertical-align: middle;
                    }
                    .idx {
                        display:none; font-size:11px; margin-top:-10px;
                    }
                }
                .item-tail {
                    position:absolute; top:5px; right:0px;
                    .btn-play {
                        width:20px; height:20px; padding:0;
                    }
                    .btn-re-ev {
                        position:absolute; top:25px; right:0px;
                        width:18px; height:18px;  padding:0;
                        border-radius:50%; border:1px solid #c8c8c8; 
                        * {
                            font-size:11px;
                        }
                    }
                }
                .pitch-dist {
                    text-align:left;padding:4px 10px;
                    select {
                        height:24px; padding-left:10px;border-radius:0; border-color:#c8c8c8; color:#666; font-size:12px;
                    }
                    .txt {
                        font-size:12px;
                    }
                    .range {
                        margin-left:20px;
                        font-size:12px;
                    }
                    .dist-compare {
                        margin-left:20px; font-size:13px; line-height:17px; cursor:pointer; 
                        input {
                            cursor:pointer; 
                        }
                    }
                }
            }
            .btn {
                border:1px solid #c8c8c8; cursor:pointer;
            }
        }

        .hide {
            display:none !important;
        }



        &.admin-view {
            .voice-list {
                .voice-item {
                    .item-body {
                        .ev-input-head {
                            display:inherit;
                        }
                        .script {
                            .grade {
                                display:inherit;
                            }
                        }
                        .report {
                            display:block;
                            .grade {
                                display:inherit;
                            }
                        }
                        .body-tail {
                            display:inherit;
                        }
                    }
                    .item-head {
                        top:10px;
                        .head {
                            margin-top:-10px;
                        }
                        .idx {
                            display:block;
                        }
                        button {
                            &.checked {
                                display: inherit;
                            }
                        }
                    }
                    .item-tail {
                        top:15px; 
                        .btn-play {
                            width:30px; height:30px;
                        }
                    }
                }
            }
        }
    }
</style>
